<div class="ad-page-header-custom">
    <div class="container">
        <h1>Reset your password</h1>
    </div>
</div>
<div class="password-reset">
    <div class="container form-holder">
        <div *ngIf="errorMessage" class="col-sm-10 col-lg-8 col-md-8 col-md-push-2 col-lg-push-2 col-sm-push-2 has-feedback">
            <div id="errorpass" class="help-block" style="color: #c00; font-size: 16px; margin-bottom: 30px">
                <span
                    >Your password was not updated because the link is invalid. Please submit another request to reset your password.</span
                >
            </div>
        </div>
        <form [formGroup]="loginForm" (ngSubmit)="onClickSubmit(passWord)" #passWord="ngForm">
            <div *ngIf="showCode == 'false' && code && isRecruiter()" class="center-alignment">
                <div class="form-group">
                    <input
                        class="form-control"
                        placeholder="Code"
                        formControlName="codeDisplay"
                        type="text"
                        [value]="codeDisplay"
                        readonly
                    />
                </div>
            </div>

            <div class="center-alignment">
                <div class="form-group">
                    <input class="form-control" placeholder="Password" formControlName="password" type="password" />

                    <div class="error-messages">
                        <ng-container *ngFor="let error of error_messages.password">
                            <div
                                class="error-message"
                                *ngIf="
                                    loginForm.get('password').hasError(error.type) &&
                                    (loginForm.get('password').dirty || loginForm.get('password').touched)
                                "
                            >
                                <span id="passglyph" class="form-control-feedback glyphicon glyphicon-remove" style="top: 0px">X</span>

                                {{ error.message }}
                            </div>
                        </ng-container>
                        <ng-container *ngFor="let error of error_messages.password">
                            <div
                                *ngIf="
                                    loginForm.get('password').valid &&
                                    (loginForm.get('password').dirty || loginForm.get('password').touched)
                                "
                            >
                                <span id="passglyph" class="form-control-green glyphicon glyphicon-remove" style="top: 0px">X</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="center-alignment">
                <div class="form-group">
                    <input class="form-control" placeholder="Confirm Password" formControlName="confirmpassword" type="password" />
                    <div class="error-messages">
                        <ng-container *ngFor="let error of error_messages.confirmpassword">
                            <div
                                class="error-message"
                                *ngIf="
                                    (loginForm.hasError('passwordNotMatch') &&
                                        (loginForm.get('confirmpassword').dirty || loginForm.get('confirmpassword').touched)) ||
                                    (loginForm.get('confirmpassword').hasError(error.type) &&
                                        (loginForm.get('confirmpassword').dirty || loginForm.get('confirmpassword').touched))
                                "
                            >
                                <span id="passglyph" class="form-control-feedback glyphicon glyphicon-remove" style="top: 0px">X</span>
                                Passwords do not match
                            </div>
                        </ng-container>
                        <ng-container *ngFor="let error of error_messages.confirmpassword">
                            <div
                                *ngIf="
                                    !loginForm.hasError('passwordNotMatch') &&
                                    (loginForm.get('confirmpassword').dirty || loginForm.get('confirmpassword').touched)
                                "
                            >
                                <span id="passglyph" class="form-control-green glyphicon glyphicon-remove" style="top: 0px">X</span>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="center-alignment">
                <p>Notice: Dice will never ask for your password over the phone or by email.</p>
            </div>
            <div class="center-alignment-button">
                <button class="form-control btn btn-primary" [disabled]="!loginForm.valid">Reset Password</button>
            </div>
        </form>

        <div
            *ngIf="successMessage"
            class="col-md-6 col-lg-6 col-sm-6 col-sm-offset-3 col-md-offset-3"
            style="top: 30px; text-align: center"
            id="successMessage"
        >
            <div class="alert alert-info" style="color: green">
                <i class="fa fa-check-circle" aria-hidden="true" style="padding-right: 0px; font-size: 15px"></i>&nbsp;&nbsp;
                <span>Your password has been reset successfully. Now login with new password.</span>
            </div>
        </div>
    </div>
</div>

<!-- <form (ngSubmit)="validateAuthCode(codeform)" #codeform="ngForm">
    <div class="form-group">
      <label for="code">Code</label>
      <input type="text" name="code" id="code" ngModel class="form-control" required>
    </div>
    <button type="submit" class="btn btn-primary">Validate Code</button>
  </form> -->
